export const CHAT_MESSAGE_TYPE = 'chat_message' as const;
export const CHAT_CHANNEL_TYPE = 'chat_channel' as const;
export const CHAT_CHANNEL_MEMBER_TYPE = 'chat_channel_member' as const;
export const CHAT_CHANNEL_READ_TYPE = 'chat_channel_read' as const;
export const CHAT_CHANNEL_FAVORITE_TYPE = 'chat_channel_favorite' as const;
export const EDGE_TYPE = 'edge' as const;
export const FILE_TYPE = 'file' as const;
export const CATEGORY_TYPE = 'category' as const;
export const ANNOUNCEMENT_TYPE = 'announcement' as const;
export const IMAGE_TYPE = 'image' as const;
export const INGREDIENT_TYPE = 'ingredient' as const;
export const INVENTORY_ITEM_TYPE = 'inventory_item' as const;
export const KNOWLEDGE_ARTICLE_TYPE = 'knowledge_article' as const;
export const MANAGER_LOGBOOK_ENTRY_TYPE = 'manager_logbook_entry' as const;
export const MENU_TYPE = 'menu' as const;
export const MENU_IMPORT_TYPE = 'menu_import' as const;
export const MENU_ITEM_TYPE = 'menu_item' as const;
export const MENU_SECTION_TYPE = 'menu_section' as const;
export const ALLERGY_MATRIX_TYPE = 'allergy_matrix' as const;
export const ALLERGY_MATRIX_ROW_TYPE = 'allergy_matrix_row' as const;
export const HEURISTIC_RULE_TYPE = 'heuristic_rule' as const;
export const FLAVOR_NODE_TYPE = 'flavor_node' as const;
export const MONETARY_VALUE_TYPE = 'monetary_value' as const;
export const ORGANIZATION_SEARCH_PREFERENCE_TYPE =
  'organization_search_preference' as const;
export const ORGANIZATION_USER_TYPE = 'organization_user' as const;
export const ORGANIZATION_TYPE = 'organization' as const;
export const PERMISSION_TYPE = 'permission' as const;
export const PROPERTY_TYPE = 'property' as const;
export const RECIPE_INGREDIENT_TYPE = 'recipe_ingredient' as const;
export const RECIPE_TYPE = 'recipe' as const;
export const SOURCE_TYPE = 'source' as const;
export const UNAVAILABLE_ITEM_TYPE = 'unavailable_item' as const;
export const USER_TYPE = 'user' as const;
export const USER_CONTACT_TYPE = 'user_contact' as const;
export const WARE_TYPE = 'ware' as const;
export const AGENT_PROFILE_TYPE = 'agent_profile' as const;
export const AGENT_RUN_TYPE = 'agent_run' as const;
export const AGENT_RUN_STEP_TYPE = 'agent_run_step' as const;
export const AGENT_EVIDENCE_TYPE = 'agent_evidence' as const;

export type EntityType =
  | typeof EDGE_TYPE
  | typeof FILE_TYPE
  | typeof CATEGORY_TYPE
  | typeof CHAT_CHANNEL_TYPE
  | typeof CHAT_CHANNEL_MEMBER_TYPE
  | typeof CHAT_CHANNEL_READ_TYPE
  | typeof CHAT_CHANNEL_FAVORITE_TYPE
  | typeof CHAT_MESSAGE_TYPE
  | typeof ANNOUNCEMENT_TYPE
  | typeof IMAGE_TYPE
  | typeof INGREDIENT_TYPE
  | typeof INVENTORY_ITEM_TYPE
  | typeof KNOWLEDGE_ARTICLE_TYPE
  | typeof MANAGER_LOGBOOK_ENTRY_TYPE
  | typeof MENU_TYPE
  | typeof MENU_IMPORT_TYPE
  | typeof MENU_ITEM_TYPE
  | typeof MENU_SECTION_TYPE
  | typeof ALLERGY_MATRIX_TYPE
  | typeof ALLERGY_MATRIX_ROW_TYPE
  | typeof HEURISTIC_RULE_TYPE
  | typeof FLAVOR_NODE_TYPE
  | typeof MONETARY_VALUE_TYPE
  | typeof ORGANIZATION_SEARCH_PREFERENCE_TYPE
  | typeof ORGANIZATION_USER_TYPE
  | typeof ORGANIZATION_TYPE
  | typeof PERMISSION_TYPE
  | typeof PROPERTY_TYPE
  | typeof RECIPE_INGREDIENT_TYPE
  | typeof RECIPE_TYPE
  | typeof SOURCE_TYPE
  | typeof UNAVAILABLE_ITEM_TYPE
  | typeof USER_TYPE
  | typeof USER_CONTACT_TYPE
  | typeof WARE_TYPE
  | typeof AGENT_PROFILE_TYPE
  | typeof AGENT_RUN_TYPE
  | typeof AGENT_RUN_STEP_TYPE
  | typeof AGENT_EVIDENCE_TYPE;
